/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { ICoreContext } from '@msdyn365-commerce/core';
import React from 'react';
import { formatDate } from '../../../utilities/format-date';

export interface ICheckoutDeliveryDateTitleProps {
    className?: string;
    isDateEnabled?: boolean;
    selectedDate?: string;
    heading?: string;
    context: ICoreContext;
}

const CheckoutDeliveryDateTitle: React.FC<ICheckoutDeliveryDateTitleProps> = ({
    className,
    isDateEnabled,
    selectedDate,
    heading,
    context
}) => {
    return (
        <div className={className}>
            {isDateEnabled && selectedDate && (
                <>
                    <span className={`${className}__calender-h`}>{heading}</span>
                    <p className='selectedDateText'>{formatDate(context, new Date(`${selectedDate}T00:00:00`))}</p>
                </>
            )}
        </div>
    );
};

export default CheckoutDeliveryDateTitle;
